import * as React from 'react';
import { useState, useEffect } from "react";
import Modal from "../../../component/Global/Modal";
import Quote from "@system/config/quote";
import { useQuoteStore } from 'src/hooks/quote';
import Auth from "@system/config/auth";
import { useDOMAttachToSystemStore } from 'src/hooks/domAttachToSystem';
import { useBOMStore } from "src/hooks/bom";
import HelperAdobeEvent from "src/support/HelperAdobeEvent";
import { useProductPricingStore } from 'src/hooks/productPricing';
import { useProductInventoryStore } from 'src/hooks/productInventory';
import { useBOMProjectStore } from "../../../hooks/bom_project";

const AddedPartQuotePopup = (props) => {
    const [status, SetStatus] = useState(false);

    const [{ AddedPartQuotePopup }, {}, {}] = useDOMAttachToSystemStore();
    const [{ addOpenQuote }, { }, { }] = useQuoteStore();
    const [{ bom_detail_by_bom_id ,bom_detail_by_bom_id_type} ] = useBOMStore();
    const [{ bom_project_list }, { }, { }] = useBOMProjectStore();
    const [, { get_inventory_by_id }, { }] = useProductInventoryStore();
    const [{ pricingList }, { }, { }] = useProductPricingStore();

    useEffect(() => {
        if (AddedPartQuotePopup) {
            SetStatus(true)
            addQuoteEvent();
        }
    }, [AddedPartQuotePopup]);

    const onHide = () => {
        SetStatus(false)
    };

    //By Ramya Kannan [Add to quote - Adobe script ]
    function addQuoteEvent(){
        let isBOM = AddedPartQuotePopup?.data?.addFrom;
        let eventType ;
        if(isBOM === "BOM"){
            eventType = "addToQuoteFromBOM";
        }else {
            eventType = "addToQuote";
        }
        localStorage.setItem("adobeEventType",eventType);
        let copyProd = AddedPartQuotePopup?.data?.single_product;
        let prodDetails = {...copyProd}  ;
        if(Array.isArray(prodDetails)){
            prodDetails[0].quantity = AddedPartQuotePopup?.data.quantity;
        }else{
            prodDetails.quantity = AddedPartQuotePopup?.data.quantity;
        }
        
        let getBomDetails = bom_detail_by_bom_id;
        let bomDetails = {...getBomDetails};
        if(bom_project_list){
            bomDetails.projectName = bom_project_list[bom_detail_by_bom_id.projectId]?.projectName
          }
        bomDetails.exactMatchCount = bom_detail_by_bom_id_type?.Exact?.count;
        bomDetails.nomatchCount = bom_detail_by_bom_id_type?.NoMatch?.count;
        bomDetails.multipleMatchCount = bom_detail_by_bom_id_type?.Multiple?.count;
        prodDetails.qas = getInventory(prodDetails?.ERPPartNumber)?.qas, //added by Ramya
        prodDetails.priceSource = getPricing(prodDetails.ERPMFRPartNumber, prodDetails.ERPPartNumber, prodDetails.ERPPartNumberModified)[0]?.priceSource; //added by Ramya
        let cartDetails = {
            "cartType":"Quote",
            "additionSource" : AddedPartQuotePopup?.data?.addFrom,
            "quoteID": addOpenQuote?.quoteLineItemId,
            "quoteType": "online"

        }
        if(Object.keys(prodDetails).length){
            HelperAdobeEvent.trackingAdobeEvent({prodDetails,cartDetails,bomDetails});
        }
    }

    //added by Ramya [Adobe script]
  const getInventory = (ERPPartNumber) => {
        return get_inventory_by_id(ERPPartNumber)
  };
  const getPricing = (
    ERPMFRPartNumber,
    ERPPartNumber,
    ERPPartNumberModified
  ) => {
    ERPPartNumber = ERPPartNumberModified ? "" : ERPPartNumber;
    if (pricingList[ERPMFRPartNumber + "-" + ERPPartNumber]) {
      return pricingList[ERPMFRPartNumber + "-" + ERPPartNumber];
    }
    return [];
  };


    const getButtonTextBySpeedBoat = () => {
        let speedBoatType = Auth.getAuthSBoat();
        switch (speedBoatType) {
            case 'B': speedBoatType = 'blue'; break;
            default: speedBoatType = 'green'; break;
        }
        return speedBoatType;
    }

    // DT - 8693 - 10-march - Quote- Submit -Unable to enter comma for decimal places for Euro target price 

    return (
        <>
            <Modal show={status} onHide={() => { onHide() }}>
                <div className="avnet-modal modal-600">
                    <div className="avnet-modal-inner">
                        <button type="button" className="close" data-dismiss="modal"
                            onClick={() => {
                                onHide()
                            }}>×</button>
                        <div className="bs5 modal-header border-0">
                            <h3 className="modal-title m-auto" id="exampleModalLabel">Request a Quote</h3>
                        </div>
                        <div className="modal-body">
                            {
                                addOpenQuote !== undefined && Object.keys(addOpenQuote).length > 0 &&
                                <>
                                    <div className="alert alert-success alert-dismissible m-b-5">
                                        <span>You've added a part to your open quote.</span>
                                        <a href={void (0)} className="close" data-dismiss="alert" aria-label="close">&times;</a>
                                    </div>
                                    <div className='m-b-10'>
                                        <b>Quote Number: </b> Open
                                    </div>
                                    <table className="table border-1">
                                        <thead>
                                            <tr className='bg-grey2'>
                                                <th>Part Number/Manufacturer  </th>
                                                <th>Qty </th>
                                                <th>Target Unit Price</th>
                                                <th>Currency</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {addOpenQuote.quantity1 !== undefined &&
                                                addOpenQuote.quantity1 > 0 &&
                                                <tr>
                                                    <td className="border-0" rowSpan="3">{props?.data?.single_product?.ERPMFRPartNumber} <br />
                                                        By {props?.data?.single_product?.ManufacturerName}</td>
                                                    <td className="border-0">{addOpenQuote.quantity1} </td>
                                                    <td className="border-0">{addOpenQuote.targetUnitPrice ? addOpenQuote.targetUnitPrice : 0 } </td>
                                                    <td className="border-0">{addOpenQuote.targetCurrency}  </td>
                                                </tr>
                                            }
                                            {addOpenQuote.quantity2 !== undefined && addOpenQuote.quantity2 > 0 ?
                                                <tr>
                                                    <td className="border-0">{addOpenQuote.quantity2} </td>
                                                    <td className="border-0">{addOpenQuote.targetUnitPrice} </td>
                                                    <td className="border-0">{addOpenQuote.targetCurrency}  </td>
                                                </tr> :
                                                <tr>
                                                    <td className="border-0">——</td>
                                                    <td className="border-0">—— </td>
                                                    <td className="border-0">—— </td>
                                                </tr>
                                            }
                                            {addOpenQuote.quantity3 !== undefined && addOpenQuote.quantity3 > 0 ?
                                                <tr>
                                                    <td className="border-0">{addOpenQuote.quantity3} </td>
                                                    <td className="border-0">{addOpenQuote.targetUnitPrice} </td>
                                                    <td className="border-0">{addOpenQuote.targetCurrency}  </td>
                                                </tr> :
                                                <tr>
                                                    <td className="border-0">——</td>
                                                    <td className="border-0">—— </td>
                                                    <td className="border-0">—— </td>
                                                </tr>
                                            }
                                        </tbody>
                                    </table>
                                    <div className="text-center quote-popup-text">
                                        <b className="d-block">You will still need to submit the quote in order to receive a response.</b>
                                        Review your quotes details by clicking the {getButtonTextBySpeedBoat()} button below or continue
                                        shopping and return to the open quote when ready.
                                    </div>
                                </>
                            }

                        </div>
                        <div className="modal-footer d-flex justify-content-center">
                            <button type="button" className="bs5 btn btn-secondary"
                                onClick={() => {
                                    onHide()
                                }}>Continue Shopping</button>
                            <button type="button" className="bs5 btn btn-primary w145"
                                onClick={() => {
                                    window.location.href = Quote.getQuoteRouteURL()
                                }}>Review Quote</button>
                        </div>
                    </div>
                </div>
            </Modal>
        </>
    )
}

export default AddedPartQuotePopup;